import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import Loader from '../../Loader';
import { UserService } from './../../../service/user.service'

const ProcessWorkflow = (params) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [title, setTitle] = useState('');
    const [city, setCity] = useState('');
    const [department, setDepartment] = useState('');
    const [phone, setPhone] = useState('');
    const [supervisorName, setSupervisorName] = useState('');
    const [supervisorEmail, setSupervisorEmail] = useState('');
    const [sponsorName, setSponsorName] = useState('');
    const [sponsorEmail, setSponsorEmail] = useState('');
    const [message, setMessage] = useState([]);
    const [pageLoading, setPageLoading] = useState(false);

    const userService = new UserService();

    useEffect(() => {
        const fetchData = async () => {
            if (params.data) {
                setFirstName(params.data.firstName);
                setLastName(params.data.lastName);
                setTitle(params.data.title);
                setCity(params.data.city);
                setDepartment(params.data.department);
                setPhone(params.data.phone);
                setSupervisorName(params.data.supervisorName);
                setSupervisorEmail(params.data.supervisorEmail);
                setSponsorName(params.data.sponsorName);
                setSponsorEmail(params.data.sponsorEmail);
            }
        }

        fetchData()
            .catch(console.error);
    }, []);

    const checkIsSponsorCompanyUser = (sponsorCompanyId) => {
        return (sponsorCompanyId !== null && sponsorCompanyId !== undefined && sponsorCompanyId !== 0);
    }

    const setFormInput = (e) => {
        if (e.target.name === "firstName") {
            setFirstName(e.target.value);
            removeMessage(1);
        }
        else if (e.target.name === "lastName") {
            setLastName(e.target.value);
            removeMessage(2);
        }
        else if (e.target.name === "title") {
            setTitle(e.target.value);
        }
        else if (e.target.name === "phone") {
            setPhone(e.target.value);
        }
        else if (e.target.name === "city") {
            setCity(e.target.value);
        }
        else if (e.target.name === "department") {
            setDepartment(e.target.value);
        }
        else if (e.target.name === "sponsorname") {
            setSponsorName(e.target.value);
            removeMessage(3);
        }
        else if (e.target.name === "sponsoremail") {
            setSponsorEmail(e.target.value);
            removeMessage(4);
        }
        else if (e.target.name === "supervisorName") {
            setSupervisorName(e.target.value);
            removeMessage(5);
        }
        else if (e.target.name === "supervisorEmail") {
            setSupervisorEmail(e.target.value);
            removeMessage(6);
        }
    };

    const checkValidation = () => {
        let result = true;
        let newMessage = [];

        let regex = new RegExp('[a-z0-9]+@[a-z0-9]+\.[a-z]{2,3}');

        if (!firstName || firstName.length === 0) {
            newMessage.push({ id: 1, text: "User's' first name is required" });
            result = false;
        }

        if (!lastName || lastName.length === 0) {
            newMessage.push({ id: 2, text: "User's last Name is required" });
            result = false;
        }


        if (checkIsSponsorCompanyUser(params.data.sponsorCompanyId)) {
            if (!sponsorName || sponsorName.length === 0) {
                newMessage.push({ id: 3, text: "User's sponsor name is required" });
                result = false;
            }

            if (!sponsorEmail || sponsorEmail.length === 0) {
                newMessage.push({ id: 4, text: "User's sponsor email is required" });
                result = false;
            }

            if (!regex.test(sponsorEmail)) {
                newMessage.push({ id: 4, text: "User's sponsor email' is not valid" });
                result = false;
            }
        }
        else {
            if (!supervisorName || supervisorName.length === 0) {
                newMessage.push({ id: 5, text: "User's supervisor/manager name is required" });
                result = false;
            }

            if (!supervisorEmail || supervisorEmail.length === 0) {
                newMessage.push({ id: 6, text: "User's supervisor/manager email is required" });
                result = false;
            }

            if (!regex.test(supervisorEmail)) {
                newMessage.push({ id: 6, text: "User's supervisor email' is not valid" });
                result = false;
            }
        }

        setMessage(newMessage);
        return result;
    };

    const removeMessage = (id) => {
        if (message.length > 0) {
            let newMessage = message.filter((m) => {
                return (m.id !== id);
            });
            setMessage(newMessage);
        }
    };

    const saveProcess = async () => {
        setPageLoading(true);
        if (checkValidation() === true) {
            let requestedUser = {
                id: params.data.id,
                applicationId: params.data.applicationId,
                application: params.data.application,
                email: params.data.email,
                supervisorEmail: supervisorEmail,
                supervisorName: supervisorName,
                name: (firstName + " " + lastName),
                firstName: firstName,
                lastName: lastName,
                status: 1,
                dateCreated: params.data.dateCreated,
                companyId: params.data.companyId,
                company: params.data.company,
                requestType: (params.data.requestType === 'NewUser' ? 1 : 2),
                title: title,
                department: department,
                city: city,
                reasonFailed: params.data.reasonFailed,
                userRequestHistories: params.data.userRequestHistories,
                sponsorEmail: sponsorEmail,
                sponsorName: sponsorName,
                sponsorCompanyId: params.data.sponsorCompanyId,
                phone: phone,
                reasonForRequest: params.data.reasonForRequest,
                password: params.data.password,
                ApplicationName: params.data.applicationName,
                ApproverRemarks: "Process the request from workflow monitor"
            };

            let result = await userService.registrationAdmin(requestedUser);
            if (result.status === 200) {
                params.callBack();
                params.onClose();
            }
        }
        setPageLoading(false);
    };

    return (
        <>
            {pageLoading && <Loader />}

            <div className="card" style={{ width: "975px", marginTop: "-5px", marginLeft: "-5px", marginBottom: "-5px", marginRight: "-5px" }}>
                <h5 className="card-header py-3">
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i> User
                </h5>
                <div className="card-body">
                    <div>
                        {(message.length > 0) ?
                            <ul>
                                {message.map(m =>
                                    <li style={{ color: "red" }} key={m.id}>{m.text}</li>
                                )}
                            </ul>
                            : ""}
                    </div>
                    <div className="ag-theme-alpine" style={{ height: "450px", marginRight: "-15px" }}>
                        <div style={{ width: "915px" }}>
                            <div className="row">
                                <div className="col-md-6">
                                    <h6>User Details</h6>
                                    <hr />

                                    <div style={{ height: "400px", overflowY: "auto" }}>
                                        <div style={{ width: "420px" }}>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>First Name</label>
                                                        <input type="text" onChange={e => setFormInput(e)} value={firstName} className="form-control" id="firstName" name="firstName" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Last Name</label>
                                                        <input type="text" onChange={e => setFormInput(e)} value={lastName} className="form-control" id="lastName" name="lastName" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Email</label>
                                                        <input type="email" value={params.data.email} className="form-control" id="email" name="email" readOnly />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Phone</label>
                                                        <input type="text" onChange={e => setFormInput(e)} value={phone} className="form-control" id="phone" name="phone" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Title</label>
                                                        <input type="text" onChange={e => setFormInput(e)} value={title} className="form-control" id="title" name="title" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Department</label>
                                                        <input type="text" onChange={e => setFormInput(e)} value={department} className="form-control" id="department" name="department" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>City</label>
                                                        <input type="text" onChange={e => setFormInput(e)} value={city} className="form-control" id="city" name="city" />
                                                    </div>
                                                </div>
                                            </div>

                                            {(checkIsSponsorCompanyUser(params.data.sponsorCompanyId)) ?
                                                <>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label>Sponsor Name</label>
                                                                <input type="text" onChange={e => setFormInput(e)} value={sponsorName} className="form-control" id="sponsorname" name="sponsorname" />

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label>Sponsor Email</label>
                                                                <input type="email" onChange={e => setFormInput(e)} value={sponsorEmail} className="form-control" id="sponsoremail" name="sponsoremail" />

                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <div className="row" >
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label>Manager Name</label>
                                                                <input type="text" onChange={e => setFormInput(e)} value={supervisorName} className="form-control" id="supervisorName" name="supervisorName" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row" >
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label>Manager Email</label>
                                                                <input type="email" onChange={e => setFormInput(e)} value={supervisorEmail} className="form-control" id="supervisorEmail" name="supervisorEmail" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Company</label>
                                                        <input type="text" onChange={e => setFormInput(e)} value={params.data.companyName} className="form-control" id="companyName" name="companyName" readOnly />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Application</label>
                                                        <input type="text" onChange={e => setFormInput(e)} value={params.data.applicationName} className="form-control" id="applicationName" name="applicationName" readOnly />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Status</label>
                                                        <input type="text" onChange={e => setFormInput(e)} value={params.data.status} className="form-control" id="status" name="status" readOnly />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <h6>Workflow Steps</h6>
                                    <hr />
                                    <div style={{ height: "400px", overflowY: "auto" }}>
                                        <ul style={{ listStyleType: "circle" }} >
                                            {params.data.userRequestHistories ? params.data.userRequestHistories.map(h =>
                                                <div style={{ padding: "5px", margin: "5px", backgroundColor: "#F0F0F0", borderRadius: "5px" }}>
                                                    <li key={h.updatedDate}>
                                                        <span style={{ width: "150px" }}>{h.updatedDate}</span>
                                                        <span style={{ marginLeft: "10px" }}>{h.details}</span>
                                                    </li>
                                                </div>
                                            ) : ""}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-footer text-muted">
                    <div style={{ textAlign: "center" }}>
                        <button className="btn btn-secondary" style={{ marginRight: "5px" }} onClick={saveProcess}>Save & Process</button>
                        <button className="btn btn-secondary" onClick={params.onClose}>Close</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProcessWorkflow;